"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalSearch = void 0;
var tslib_1 = require("tslib");
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
var react_1 = tslib_1.__importStar(require("react"));
var BaseIcon_1 = tslib_1.__importDefault(require("@ad/anq-iconfont.macro/lib/components/BaseIcon"));
var NormalSearch = /** @class */ (function (_super) {
    tslib_1.__extends(NormalSearch, _super);
    function NormalSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconSvg = function () { return (react_1.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 1024 1024", version: "1.1", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
            react_1.default.createElement("path", { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6c3.2 3.2 8.4 3.2 11.6 0l43.6-43.5c3.2-3.2 3.2-8.4 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" }))); };
        return _this;
    }
    NormalSearch.prototype.render = function () {
        return react_1.default.createElement(BaseIcon_1.default, tslib_1.__assign({ component: this.iconSvg }, this.props));
    };
    return NormalSearch;
}(react_1.Component));
exports.NormalSearch = NormalSearch;
//# sourceMappingURL=NormalSearch.js.map